@import (reference) '../../../../../../../constants/spacing.module.less';

.product-grid-footer {
  padding: @space-8 @space-0 @space-8 @space-16;
  font-size: 12px;
  border-top: 1px solid var(--grey-300);
}
